<template>
  <div>
    <div class="user-info-head-dd">{{ userNickName }}</div>
  </div>
</template>

<script>
  export default {
    props: {
      user: {
        type: Object,
        default: () => {
          return {}
        },
      },
    },
    data() {
      return {
        userNickName: '',
      }
    },
    watch: {
      user: {
        immediate: true,
        handler() {
          let disName = this.user.userName
          if (disName) {
            let disLength = disName.length
            let shortName = disName.substring(disLength - 3, disLength)
            this.userNickName = shortName
          }
        },
      },
    },
    created() {},
    methods: {},
  }
</script>
<style scoped lang="scss">
  .user-info-head {
    position: relative;
    display: inline-block;
    height: 62px;
    margin-top: 40px;
    .img-lg {
      width: 62px;
      height: 62px;
    }
  }

  .user-info-head:hover:after {
    content: '+';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    color: #eee;
    background: rgba(0, 0, 0, 0.5);
    font-size: 24px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    cursor: pointer;
    line-height: 65px;
    border-radius: 50%;
  }

  .user-info-head-dd {
    position: relative;
    display: inline-block;
    height: 62px;
    line-height: 62px;
    width: 62px;
    text-align: center;
    color: #fff;
    border-radius: 100%;
    margin-top: 40px;
    background-color: rgb(24, 144, 255);
  }
</style>
